import React from "react";
import { getColorByNumber, pxToRem, toNumberFixed } from "@/util/common";
import { createUseStyles } from "react-jss";
import useCustomStyles from "@/hooks/useCustomStyles";
import { Grid, Skeleton } from "antd-mobile";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";

const MonthlyWeger: React.FC<{ data: Record<string, any> }> = ({ data }) => {
	const classes = useStyles();
	const useClasses = useCustomStyles();
	const { t } = useCustomTranslation();
	return (
		// 这修改了ui跨度
		<div className={`${useClasses.cardWrap} ${classes.MonthlyWeger}`}>
			<Grid columns={2} gap={[0, 16]}>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("MonthlyWeger")}</dt>
						{!isEmpty(data) ? (
							<dd>{toNumberFixed(data.monthWager, 2)}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("MonthlyProfit")}</dt>
						{!isEmpty(data) ? (
							<dd className={getColorByNumber(+data.monthProfit)}>
								{toNumberFixed(data.monthProfit, 2)}
							</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				{/* 	<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("Members")}</dt>
						{!isEmpty(data) ? (
							<dd>{data.members}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("ActiveMember")}</dt>
						{!isEmpty(data) ? (
							<dd>{data.activeMembers}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("RechargeNumbers")}</dt>
						{!isEmpty(data) ? (
							<dd>{data.rechargeMembers}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>--</dt>
						<dd>--</dd>
					</dl>
				</Grid.Item> */}
			</Grid>
		</div>
	);
};

export default MonthlyWeger;

const useStyles = createUseStyles({
	MonthlyWeger: {
		padding: {
			left: pxToRem(18),
			right: pxToRem(18),
			top: pxToRem(15),
			bottom: pxToRem(15),
		},
	},
});
